<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NEvA7n/images/9780316338899.jpg?1731806672813" alt="This image is the cover for the book Girl With Curious Hair"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Girl With Curious Hair
      </h1>
      <p class="bookDescription body article font2">
        <p>Remarkable, hilarious, and unsettling re-imaginations of reality by "a dynamic writer of extraordinary talent" (<i>New York Times Book Review</i>).<br/><br/>David Foster Wallace was one of America's most prodigiously talented and original young writers, and <i>Girl with Curious Hair</i> displays the full range of his gifts. From the eerily "real," almost holographic evocations of historical figures such as Lyndon Johnson and overtelevised game-show hosts and late-night comedians to the title story, in which terminal punk nihilism meets Young Republicanism, Wallace renders the incredible comprehensible, the bizarre normal, the absurd hilarious, the familiar strange.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Foster Wallace
      </h2>
      
      <p class="authorDescription body article">David Foster Wallace was born in Ithaca, New York, in 1962 and raised in Illinois, where he became a regionally ranked junior tennis player. He received bachelor of arts degrees in philosophy and English from Amherst College and wrote what would become his first novel, <I>The Broom of the System</I>, as his senior English thesis. He received a master of fine arts degree from the University of Arizona in 1987 and briefly pursued graduate work in philosophy at Harvard University. His second novel,<I> Infinite Jest</I>, was published in 1996. Wallace taught creative writing at Emerson College, Illinois State University, and Pomona College. His books include the story collections <I>Girl with Curious Hair</I>, <I>Brief Interviews with Hideous Men</I>, and <I>Oblivion</I> and<I></I>the essay collections <I>A Supposedly Fun Thing I'll Never Do Again </I>and <I>Consider the Lobster</I>. He was awarded a MacArthur Fellowship, a Lannan Literary Award, and a Whiting Writers' Award, and was appointed to the Usage Panel for the American Heritage Dictionary of the English Language. He died in 2008.  His last novel, <I>The Pale King</I>, was published in 2011.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?10167cc7